import { render, staticRenderFns } from "./newPactivity.vue?vue&type=template&id=79b8780c&scoped=true"
import script from "./newPactivity.vue?vue&type=script&lang=js"
export * from "./newPactivity.vue?vue&type=script&lang=js"
import style0 from "./newPactivity.vue?vue&type=style&index=0&id=79b8780c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8780c",
  null
  
)

export default component.exports